export const navLinks = [
  { label: "FILMS", href: "#films" },
  { label: "FORMATS", href: "#formats" },
  { label: "PROCESS", href: "#process" },
  { label: "START", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const stats = [
  { value: "9+", caption: "YEARS OF BRAND WORK", accent: false },
  { value: "200+", caption: "BRANDS", accent: false },
  { value: "10+", caption: "COUNTRIES", accent: false },
  { value: "95%", caption: "REPEAT CLIENTS", accent: true },
];

// Paste each brand's logo URL (SVG or transparent PNG) into `logo`.
// Logos are shown in white at 60%; any brand without a working logo falls back to its name.
export const clients = [
  { name: "Intel", logo: "https://cdn.simpleicons.org/intel/ffffff" },
  { name: "Philips", logo: "https://cdn.simpleicons.org/philips/ffffff" },
  { name: "MG Motor", logo: "" },
  { name: "Instamojo", logo: "" },
  { name: "Vahan", logo: "" },
  { name: "Devtron", logo: "" },
  { name: "NexusNovus", logo: "" },
  { name: "Talent500", logo: "" },
  { name: "Xoxoday", logo: "" },
];

const PLAN_CDN = "https://cdn.magicpatterns.com/patterns/generated-images/";

export const plans = [
  {
    id: "single",
    name: "Single Film",
    line: "One ad film, TVC or launch teaser, done properly.",
    formats: "AD FILM · TVC · TEASER",
    image: `${PLAN_CDN}a114c0f8-eb31-4fec-a94c-145a05902daa.jpg`,
    alt: "SUV on a misty mountain road at blue hour",
    examples: ["A 60s launch film for a new SUV", "A 30s festive jewellery TVC", "A teaser for a product drop"],
  },
  {
    id: "series",
    name: "Film Series",
    line: "A web series or microdrama, built episode by episode.",
    formats: "WEB SERIES · MICRODRAMA",
    image: `${PLAN_CDN}30732e9f-f64d-470a-9240-e334eb9b0064.jpg`,
    alt: "Night hospital corridor under fluorescent light",
    examples: ["An 8-episode branded drama", "A 10 × 90s microdrama for OTT", "A founder story told in chapters"],
  },
  {
    id: "social",
    name: "Social Videos",
    line: "Reels, hooks and social cuts, made for the first 3 seconds.",
    formats: "REELS · HOOKS · SOCIAL",
    image: `${PLAN_CDN}5b83b934-5004-43eb-80a3-43ffb482d884.jpg`,
    alt: "Dancer leaping in pink and blue neon light",
    examples: ["20 hook variants of one ad", "A month of reels for a launch", "9:16 cutdowns of a hero film"],
  },
];

export const faqs = [
  { q: "Is it all AI?", a: "The production is. The direction, writing, edit, sound and final eye are human." },
  { q: "Who owns the film?", a: "You do, with full commercial rights on final payment." },
  { q: "Can you use our real product and people?", a: "Yes, with consent. We build from your product files and brand assets." },
  { q: "Do you work with agencies?", a: "Yes, white-label and under NDA. You keep the client." },
  { q: "How long does it take?", a: "It depends on length and versions. We map the schedule after one call." },
];

export const footerColumns = [
  {
    title: "STUDIO",
    links: [
      { label: "Films", href: "#films", external: false },
      { label: "Formats", href: "#formats", external: false },
      { label: "Process", href: "#process", external: false },
      { label: "Start a film", href: "#pricing", external: false },
    ],
  },
  {
    title: "BRANDHERO",
    links: [
      { label: "brandhero.design ↗", href: "https://brandhero.design", external: true },
      { label: "Case studies ↗", href: "https://brandhero.design", external: true },
    ],
  },
  {
    title: "SOCIAL",
    links: [
      { label: "Instagram", href: "#", external: true },
      { label: "LinkedIn", href: "#", external: true },
      { label: "YouTube", href: "#", external: true },
    ],
  },
];
